module.exports = __webpack_public_path__ + "img/titleid.85889944.png";